import React, { ReactElement, useEffect, useState } from 'react';
import { Client, Entente } from '../../../../../common/src/entities';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { ChampsEntente } from './DetailsEntente';
import { useNavigate } from 'react-router-dom';
import ActiviteEntente from '../../../../../common/src/entities/activite-entente.entity';

const ENTETE_CREER_INCONNU = "Création d'une nouvelle entente";
const ENTETE_CREER_CONNU = "Création de l'entente ";
const ALERT_ENTENTE = 'Entente';
const ALERT_CREER_SUCESS = 'créé(e) avec succès!';

/**
 * Page de création d'une entité client contenant les boutons
 * du haut et le formulaire à remplir
 *
 * @returns page html du formulaire
 */
export default function CreerEntente(props: Partial<PropsDeCreationEntite<Entente>>): ReactElement {
    const bsAlert = useAlertDialog();
    const navigate = useNavigate();

    const [valeursInitiales, setValeursInitiales] = useState<Entente>(new Entente());

    useEffect(() => {
        let title = 'Nouvelle Entente - Dashboard';
        if (valeursInitiales.name) {
            title = `${valeursInitiales.name} - Dashboard`;
        }
        document.title = title;
    }, [valeursInitiales.name]);

    /**
     * Affiche le titre en haut du formulaire de création du client
     *
     * @param c entité Client
     * @returns html du titre
     */
    function texteEntete(c: Client): JSX.Element {
        return (
            <>
                <small className="text-muted">{c.name ? ENTETE_CREER_CONNU : ENTETE_CREER_INCONNU}</small>
                {c.name && c.name}
            </>
        );
    }

    /**
     * Callback pour un formulaire envoyé à la BD avec succès.
     * Affiche le popup de confirmation la première fois ensuite
     * seulement un crochet dans le bouton Sauvegarder
     *
     * @param c entité Entente
     */
    function gererSucces(c: Entente): void {
        c['activiteEntentes'] = ([null] as unknown) as ActiviteEntente[];
        if (valeursInitiales.id === undefined) bsAlert(`${ALERT_ENTENTE} ${c.name} ${ALERT_CREER_SUCESS}`, 'success');
        setValeursInitiales(c);

        navigate('/dashboard/ententes/' + c.id, { replace: true });
    }

    /**
     * Callback pour netoyer l'objet à envoyer afin de respecter l'entité de la BD.
     *
     * @param c entité Entente
     */
    function nettoyer(c: Entente): void {
        delete c.client['label'];

        if (!c['copie_locale_client']) {
            delete (c as Partial<typeof c>).contacts;
            delete (c as Partial<typeof c>).roles;
        }
    }

    return (
        <FormulaireCreationEntite
            texteEntete={texteEntete}
            entite={Entente}
            //schema={schemaEntente}
            nettoyer={nettoyer}
            succes={gererSucces}
            valeursInitiales={valeursInitiales}
            aussiEnvoyerCreated_at
            properties_to_reassign={{ id: 'id' }}
            {...props}
        >
            <ChampsEntente />
        </FormulaireCreationEntite>
    );
}
